import React, { useState, useEffect } from "react";
import "./Form2.scss";
import { FiArrowRight } from "react-icons/fi";
import { connect } from "react-redux";

import { signup } from "../../../store/auth/actions";

const Form2 = (props) => {
  const [state, setstate] = useState({
    dob: "",
  });
  const disabledBtn = () => {
    if (!state.dob)
      return true;
    return false;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setstate({
      ...state,
      [name]: value,
    });
  };
  const handleSubmit = async() => {
    await props.signup({
      userId: props.userData.signupData.userId,
      dob: state.dob,
    });
    props.clicking();
  };
  return (
    <div className="Form2 w-100">
      <div className="h1">My date of birth is ...</div>
      <div className="input-wrapper">
        <input
          type="date"
          className="input form-control"
          value={state.dob}
          name="dob"
          onChange={handleChange}
          required
        />
      </div>
      <div className="note text-muted text-left">
        Please enter your real date of birth. You will be able to hide it from
        your profile later.
      </div>
      <div className="my-5"></div>
      <div className="d-flex justify-content-end align-items-center ">
        <button
          className="btn btn-primary rounded-3 btn-lg mt-4"
          disabled={disabledBtn()}
          onClick={()=> handleSubmit()}
        >
          Next
          <FiArrowRight className="ml-3" />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth,
});

export default connect(mapStateToProps, {
  signup
})(Form2);
